<div class="listing" (mouseenter)="onlistinghovered.emit(listing)" *ngIf="listing">


  <span class="close-span" (click)="closePopup.emit()">
    <p class="modal-clost-btn fs-15" aria-label="Close">&times;</p>
  </span>


  <div [id]="'popupcontrols'+ (listing.id || listing._id) + (isMobile ? 'mobile' : '')" class="carousel"
    data-bs-interval="false">
    <ol class="carousel-indicators" *ngIf="((listing.room || listing.property).images).length > 1">
      <li [attr.data-bs-target]="'#popupcontrols'+  (listing.id || listing._id) + (isMobile ? 'mobile' : '')"
        *ngFor="let image of ((listing.room || listing.property).images); let i = index" [attr.data-bs-slide-to]="i"
        class=" {{ (i == 0) ? 'active' : ''}}"></li>
    </ol>
    <div class="carousel-inner">
      <div [routerLink]="['/listings', listing.id || listing._id]"
        *ngFor="let image of ((listing.room || listing.property).images); let i = index"
        class="image lozad carousel-item {{ (i == 0) ? 'active' : ''}}"
        [style.background-image]="'url(' + image.url + ')'">
        <img class="image w-100" [attr.data-src]="image.url" [alt]="(listing.room || listing.property).display_name" />
      </div>
      <button class="carousel-control-prev" type="button" *ngIf="((listing.room || listing.property).images).length > 1"
        [attr.data-bs-target]="'#popupcontrols'+ (listing.id || listing._id) + (isMobile ? 'mobile' : '')"
        data-bs-slide="prev">
        <fa-icon class="fa-icon-md text-black" [icon]="icons.arrowLeft"></fa-icon>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" *ngIf="((listing.room || listing.property).images).length > 1"
        [attr.data-bs-target]="'#popupcontrols'+ (listing.id || listing._id) + (isMobile ? 'mobile' : '')"
        data-bs-slide="next">
        <fa-icon class="fa-icon-md text-black" [icon]="icons.arrowRight"></fa-icon>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
  <div class=" d-flex justify-content-between flex-column p-4">

    <div class="d-flex justify-content-between align-items-center fs-11 ">
      <!-- <div *ngIf="(listing.user)?.trusted_partner" class="d-flex">
        <img class="me-2" src="assets/icons/badge-check 1.svg" />
      </div> -->

      <div>
        <p class="price"><span>FROM</span>
        </p>
        <p class="price">{{(listing.room || listing.property).rent?.amount | currency: listing.rent?.currency}}
          <span>{{listing.rent?.cycle |
            rentCycle }}</span>
        </p>
      </div>
      <!-- <span *featureToggle="'favourite'" >
        <img class="fav" src="{{!favourite ?  'assets/images/listings/unfavourite.svg' : 'assets/images/listings/favourite.svg'}}" alt="" alt="favourite icon">

      </span> -->
    </div>


    <h6 class="title" [routerLink]="['/listings', listing.id || listing._id]">
      {{
      (listing.room || listing.property).display_name!.length > 24 ?
      (listing.room
      ||
      listing.property).display_name?.slice(0,25) + "..." : (listing.room
      ||
      listing.property).display_name}}
    </h6>
    <div class="props">
      <span>
        <h6 *ngIf="(listing.property).guests_allowed">
          <span>{{(listing.property).guests_allowed}} Guests</span> <span class="dot-circle"></span>
        </h6>
        <h6 *ngIf="(listing.property).total_rooms">
          <fa-icon [icon]="icons.bed" class="black"></fa-icon> <span>{{(listing.property).total_rooms}}</span>
          <span class="dot-circle"></span>
        </h6>
        <h6 *ngIf="(listing.property).bathrooms">
          <fa-icon [icon]="icons.bath" class="black"></fa-icon> <span>{{(listing.property).bathrooms}}</span>
          <span class="dot-circle"></span>
        </h6>

        <h6>
          <fa-icon [icon]="icons.map" class="black">
          </fa-icon>

          <span>
            {{(listing.property?.address?.postcode || '') | postcode}}
          </span>
        </h6>

      </span>
    </div>
  </div>

</div>
